import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListLanguages from '../../components/content/list-languages.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContentLanguagesView = () => {
  const pageTitle = PAGE_TITLE_LIST.CONTENT_LANGUAGES;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListLanguages />
    </AppLayout>
  );
};

export default ContentLanguagesView;
